import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ActivityIcon } from '../../../assets/icons/activity-icon.svg';
import { ReactComponent as DotCircle } from '../../../assets/icons/dot-circle.svg';
import { ReactComponent as EditPencilCard } from '../../../assets/icons/edit-pencil-card.svg';
import { ReactComponent as EditPencilDark } from '../../../assets/icons/iconsDark/action-edit-icon-dark.svg';
import { ReactComponent as MoreIcon } from '../../../assets/icons/more-icon.svg';
import profile from '../../../assets/images/profiles/profile.jpg';
import ThemeContext from '../../../contexts/theme-context/ThemeContext';
import { UserCardDetails } from '../../../interface/user-management.interface';
import DropDown from '../../../shared-components/drop-down/DropDown';

/**
 * User Card Body page function component
 */
function UserCardBody({ userDetails, activeLog, menuList, editFunction }: UserCardDetails) {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation('userManagement');
  return (
    <div className="card-body">
      <div className="card-header">
        <div className="card-header-item-image">
          <img src={profile} alt="profile" />
        </div>
        <div className="card-header-item-title">
          <div className="title">{userDetails.name}</div>
          <div className="sub-title">{userDetails.accountId}</div>
        </div>
        <div className="card-header-item-tag">
          {!userDetails.deletedAt ? (
            <div className="tag-success-label">
              <DotCircle /> {t('active')}
            </div>
          ) : (
            <div className="tag-danger-label">
              <DotCircle /> {t('inactive')}
            </div>
          )}
        </div>
        <div className="card-header-item-icon">
          {!userDetails.deletedAt && (
            <DropDown list={menuList} icon={<MoreIcon />} id={userDetails.id} />
          )}{' '}
        </div>
      </div>
      <div className="card-body-content">
        <div className="user-details">
          <div className="title">{t('role')}</div>
          <div className="value">{userDetails.roleName}</div>
        </div>
        <div className="user-details">
          <div className="title">{t('date')}</div>
          <div className="value">{userDetails.date}</div>
        </div>
        <div className="user-details">
          <div className="title">{t('contact')}</div>
          <div className="value">{userDetails.email}</div>
        </div>
        <div className="user-details">
          <div className="title">{t('permission')}</div>
          <div className="value">
            {!userDetails.deletedAt && (
              <div
                onClick={(even) => {
                  even.stopPropagation();
                  editFunction(userDetails);
                }}
                role="presentation"
                className="btn">
                {theme === 'light' ? <EditPencilCard /> : <EditPencilDark />}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card-body-footer">
        <div className="button-wrap">
          <button
            type="button"
            onClick={(event) => activeLog(userDetails, event)}
            className="back-button on-hover">
            <span>
              <ActivityIcon />
            </span>
            <span>{t('activityLog')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserCardBody;
